import { useState } from "react";

import { useMediaQuery } from "@/hooks/use-media-query";
import { MOBILE_QUERY } from "../../../financeiro-obras.constants";
import type { FinanceiroObraDetailDialogProps } from "./types-financeiro-obra-detail-dialog";

/**
 * Detalhamento financeiro da obra, aberto pela lupa da listagem (HU 2679). Por ora só a aba
 * "Planejamento e Controle" é navegável, com o acesso às fichas financeiras da obra. A ação aparece
 * sempre; sem `hub.financeiro:view-fmm`, a modal das fichas mostra "Acesso não autorizado".
 */
export function useFinanceiroObraDetailDialog({ obra, onClose }: FinanceiroObraDetailDialogProps) {
  const [fichasAberto, setFichasAberto] = useState(false);
  const isMobile = useMediaQuery(MOBILE_QUERY);

  return {
    obraId: obra.id,
    codigo: obra.codigo,
    embarcacao: obra.embarcacao.nome,
    statusFinanceiro: obra.statusFinanceiro,
    isMobile,
    // Figma mobile (13596:706665): os botões do detalhamento são small (31); no desktop, 35.
    acaoSize: isMobile ? ("small" as const) : undefined,
    // Referência do detalhamento (mobile 13596:706630 e desktop): título 16 Medium, no lugar do 20 Bold do DS.
    tituloClassName: "p-dialog-title-sm",
    fichasAberto,
    abrirFichas: () => setFichasAberto(true),
    voltarDasFichas: () => setFichasAberto(false),
    fechar: onClose,
  };
}
